module.exports = __webpack_public_path__ + "static/HTH4-fede642f8ae01e5e95fbba4f19a2032f.jpg";